import styled, { css } from "styled-components";
import * as React from "react";

import { SSOProviders } from "src/core/shared/store/global/global.reducer";

import Button, { IButtonProps } from "./Button";

type SocialLoginButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & IButtonProps & {
  socialType: SSOProviders;
};

export const SocialLoginButton: React.ReactFCWithChildren<SocialLoginButtonProps> = props => {
  /**
   * Returns the image path for each social type
   */
  const socialButtonImage = React.useMemo(() => {
    switch (props.socialType) {
      case SSOProviders.Microsoft:
        return "/assets/ms_signin.svg";

      case SSOProviders.Google:
        return "/assets/google_signin.png";

      default:
        return "";
    }
  }, [ props.socialType ]);

  return (
    <StyledButton
      className={`${props.socialType}`}
      {...props}
      loading={false}
    >

      <img
        className="social-image"
        src={socialButtonImage}
      />

    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  ${() => css`
    background: transparent;
    padding: 0;
    border-radius: 0;
    border: none;
    
    .social-image {
      width: 200px;
    }
  `}
`;
